<main fxLayout="column" fxLayoutAlign="center center">
    <img style="width: 30%;" src="assets/ic_maintenance.svg">
    <h1 style="color: #2D3C51; margin: -4% 0 0 0; font-weight: bold; font-size: 32px; font-family: 'Roboto' !important;">SYSTEM MAINTENANCE</h1>
    <div fxLayoutAlign="center center">
        <h3 fxFlex="60" style="color: #415065; margin: 20px 0 0 0; font-family: 'Roboto' !important; text-align: center; font-weight: 500">{{message}}</h3>
    </div>
    <h4 style="color: #9098B0; margin: 20px 0 0 0; font-family: cairo !important; font-weight: 600;">{{message_ar}}</h4>
    <button (click)="handleOK()" style="background-color: #E9EAEF; color: #213060; line-height: 34px; padding: 0 25px; border-radius: 10px; border: none; margin-top: 20px; cursor: pointer;" mat-raised-button>Ok
    </button>
</main>